import { ChangeDetectionStrategy, Component, ComponentRef, effect, inject, input, output, Type, viewChild, ViewContainerRef } from '@angular/core';
import { FFlowModule } from '@foblex/flow';
import { FlowDispatchEvent, FlowNode } from '../../models';
import { FlowNodeComponentRegistry } from '../../services/flow-node-component-registry.service';
import { FlowAbstractNodeComponent } from '../flow-abstract-node.component';
import { FlowBaseNodeComponent } from '../nodes/flow-base-node/flow-base-node.component';

@Component({
  selector: 'iot-platform-ui-flow-node',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FFlowModule],
  templateUrl: './flow-node.component.html'
})
export class FlowNodeComponent {
  public readonly node = input.required<FlowNode>();
  dispatchEvent = output<FlowDispatchEvent>();
  readonly nodeContainerRef = viewChild('nodeContainer', { read: ViewContainerRef });
  currentComponentRef: ComponentRef<FlowAbstractNodeComponent<FlowNode, any>> | null = null;

  private readonly registry = inject(FlowNodeComponentRegistry);

  constructor() {
    effect(() => {
      this.createComponent();
    });
  }

  clearFieldComponent(): void {
    if (this.currentComponentRef) {
      this.currentComponentRef.destroy();
      this.currentComponentRef = null;
    }
  }

  createComponent(): void {
    this.clearFieldComponent();
    const node = this.node();
    const component = this.getComponent(node);
    if (!component) return;

    const container = this.nodeContainerRef();
    if (!container) {
      console.warn('Field container not found in menu template');
      return;
    }

    this.currentComponentRef = container.createComponent(component);
    this.currentComponentRef.setInput('node', node);

    const instance = this.currentComponentRef.instance;
    if (instance.dispatchEvent) {
      instance.dispatchEvent.subscribe((event) => {
        this.dispatchEvent.emit(event);
      });
    }
  }

  getComponent(node: FlowNode): Type<FlowAbstractNodeComponent<FlowNode, any>> {
    const registeredComponent = this.registry.resolve(node.type);
    if (registeredComponent) {
      return registeredComponent;
    }
    return FlowBaseNodeComponent;
  }
}
